module.exports = __webpack_public_path__ + "img/pusicov_landscape.7a1533f5.png";